import React from 'react';
import { BarChart3, TrendingUp } from 'lucide-react';
export function Traction() {
  return <section className="py-20 lg:py-32 bg-slate-900 relative" data-id="element-297">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-298">
        <div className="flex flex-col md:flex-row items-center justify-between mb-16 gap-8" data-id="element-299">
          <div className="max-w-2xl" data-id="element-300">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-301">
              Built for Scale
            </h2>
            <p className="text-xl text-slate-400" data-id="element-302">
              Our modular infrastructure model enables rapid deployment and
              predictable growth, creating a clear path to profitability.
            </p>
          </div>
          <div className="p-4 bg-slate-800 rounded-2xl border border-slate-700 hidden md:block" data-id="element-303">
            <BarChart3 className="w-12 h-12 text-emerald-400" data-id="element-304" />
          </div>
        </div>

        {/* Enhanced Chart Representation */}
        <div className="bg-slate-950 rounded-3xl p-8 md:p-12 border border-slate-800 relative overflow-hidden" data-id="element-305">
          {/* Background glow effect */}
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-emerald-900/10 blur-[100px] rounded-full pointer-events-none" data-id="element-306"></div>

          <div className="flex items-center justify-between mb-8" data-id="element-307">
            <div className="text-sm font-medium text-slate-500" data-id="element-308">
              5-Year Growth Trajectory
            </div>
            <div className="flex items-center gap-2 text-emerald-400 text-sm" data-id="element-309">
              <TrendingUp className="w-4 h-4" data-id="element-310" />
              <span className="font-semibold" data-id="element-311">650% Growth</span>
            </div>
          </div>

          <div className="h-96 mt-12 flex items-end justify-between gap-3 sm:gap-6 lg:gap-8 relative" data-id="element-312">
            {/* Enhanced Grid lines with labels */}
            <div className="absolute inset-0 flex flex-col justify-between pointer-events-none" data-id="element-313">
              <div className="flex items-center" data-id="element-314">
                <span className="text-xs text-slate-600 mr-2" data-id="element-315">$15M</span>
                <div className="border-t border-slate-700/50 w-full" data-id="element-316"></div>
              </div>
              <div className="flex items-center" data-id="element-317">
                <span className="text-xs text-slate-600 mr-2" data-id="element-318">$11M</span>
                <div className="border-t border-slate-700/30 w-full" data-id="element-319"></div>
              </div>
              <div className="flex items-center" data-id="element-320">
                <span className="text-xs text-slate-600 mr-2" data-id="element-321">$7M</span>
                <div className="border-t border-slate-700/30 w-full" data-id="element-322"></div>
              </div>
              <div className="flex items-center" data-id="element-323">
                <span className="text-xs text-slate-600 mr-2" data-id="element-324">$3M</span>
                <div className="border-t border-slate-700/30 w-full" data-id="element-325"></div>
              </div>
              <div className="flex items-center" data-id="element-326">
                <span className="text-xs text-slate-600 mr-2" data-id="element-327">$0</span>
                <div className="border-t border-slate-700/50 w-full" data-id="element-328"></div>
              </div>
            </div>

            {/* Enhanced Bars with segments */}
            {[{
            year: 'Year 1',
            height: '20%',
            label: 'Pilot Launch',
            revenue: '$480K',
            metric: '1 Facility',
            color: 'from-emerald-900/60 via-emerald-700/70 to-emerald-500/90'
          }, {
            year: 'Year 2',
            height: '35%',
            label: 'Regional Expansion',
            revenue: '$1.8M',
            metric: '3 Facilities',
            color: 'from-emerald-900/60 via-emerald-600/80 to-emerald-500/95'
          }, {
            year: 'Year 3',
            height: '55%',
            label: 'Multi-Market Scale',
            revenue: '$4.2M',
            metric: '7 Facilities',
            color: 'from-emerald-800/70 via-emerald-600/85 to-emerald-400'
          }, {
            year: 'Year 4',
            height: '75%',
            label: 'Profitability Achieved',
            revenue: '$8.5M',
            metric: '12 Facilities',
            color: 'from-emerald-700/80 via-emerald-500/90 to-emerald-400'
          }, {
            year: 'Year 5',
            height: '100%',
            label: 'Market Leadership',
            revenue: '$15M+',
            metric: '20+ Facilities',
            color: 'from-emerald-600/90 via-emerald-500 to-emerald-300'
          }].map((data, i) => <div key={i} className="flex-1 flex flex-col items-center group relative" data-id="element-329">
                {/* Revenue label above bar - always visible */}
                <div className="absolute -top-20 left-1/2 -translate-x-1/2 text-center z-10 transition-transform group-hover:-translate-y-1" data-id="element-330">
                  <div className="text-emerald-400 font-bold text-base md:text-lg mb-1" data-id="element-331">
                    {data.revenue}
                  </div>
                  <div className="text-slate-500 text-xs font-medium" data-id="element-332">
                    {data.label}
                  </div>
                </div>

                {/* Enhanced Bar with segments and animation */}
                <div className={`w-full bg-gradient-to-t ${data.color} rounded-t-xl transition-all duration-700 group-hover:scale-105 relative overflow-hidden shadow-lg border-t-2 border-emerald-400/30`} style={{
              height: data.height,
              animationDelay: `${i * 100}ms`
            }} data-id="element-333">
                  {/* Shine effect */}
                  <div className="absolute inset-0 bg-gradient-to-b from-white/20 via-transparent to-transparent" data-id="element-334"></div>

                  {/* Segmented lines to show growth stages */}
                  <div className="absolute inset-x-0 top-1/3 h-px bg-white/10" data-id="element-335"></div>
                  <div className="absolute inset-x-0 top-2/3 h-px bg-white/10" data-id="element-336"></div>

                  {/* Glow effect on hover */}
                  <div className="absolute inset-0 bg-emerald-400/0 group-hover:bg-emerald-400/10 transition-colors duration-300" data-id="element-337"></div>
                </div>

                {/* Year and metric labels */}
                <div className="mt-5 text-center" data-id="element-338">
                  <div className="text-sm font-bold text-white mb-1" data-id="element-339">
                    {data.year}
                  </div>
                  <div className="text-xs text-emerald-400 font-semibold bg-emerald-500/10 px-2 py-1 rounded-full border border-emerald-500/20" data-id="element-340">
                    {data.metric}
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}